import { render, staticRenderFns } from "./UploadDocTabs.vue?vue&type=template&id=5223f2e8&"
import script from "./UploadDocTabs.vue?vue&type=script&lang=js&"
export * from "./UploadDocTabs.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocTabs.vue?vue&type=style&index=0&id=5223f2e8&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5223f2e8')) {
      api.createRecord('5223f2e8', component.options)
    } else {
      api.reload('5223f2e8', component.options)
    }
    module.hot.accept("./UploadDocTabs.vue?vue&type=template&id=5223f2e8&", function () {
      api.rerender('5223f2e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/production/jobcard/jobcard-view/components/UploadDocTabs.vue"
export default component.exports